import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import {
  getStatusBadgeClass,
  getSubscriptionStatusMeta,
  historyTableStyles
} from './historyTableUtils'

const formatDate = dateString => {
  if (!dateString) return 'N/A'

  return new Date(dateString).toLocaleDateString('es-CL', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}

const formatEndDate = dateString => formatDate(dateString)

const SubscriptionHistoryTable = ({ subscriptions = [] }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (subscriptions.length === 0) {
    return (
      <div className='space-y-4'>
        <h2 className='text-xl font-bold text-gray-800'>Historial de Suscripciones</h2>
        <div className='rounded-2xl border border-dashed border-gray-200 bg-gray-50/70 py-10 text-center text-sm text-gray-500'>
          No hay historial de suscripciones
        </div>
      </div>
    )
  }

  if (isMobile) {
    return (
      <div className='space-y-4'>
        <div className='flex items-center justify-between'>
          <h2 className='text-xl font-bold text-gray-800'>Historial de Suscripciones</h2>
          <span className='text-xs font-medium uppercase tracking-[0.18em] text-gray-400'>
            {subscriptions.length} registros
          </span>
        </div>

        <div className='space-y-3'>
          {subscriptions.map(subscription => {
            const statusMeta = getSubscriptionStatusMeta(subscription)

            return (
              <article
                key={subscription.id}
                className='rounded-2xl border border-gray-100 bg-white p-4 shadow-sm'
              >
                <div className='flex items-start justify-between gap-3'>
                  <div>
                    <p className='text-sm font-bold text-slate-800'>
                      {subscription.plan?.name || 'Sin plan'}
                    </p>
                    {/*<p className='mt-1 text-[11px] text-gray-500'>
                      Suscripcion #{subscription.id}
                    </p>*/}
                  </div>
                  <span className={getStatusBadgeClass(statusMeta.tone)}>{statusMeta.label}</span>
                </div>

                <div className='mt-3 grid grid-cols-2 gap-3'>
                  <div>
                    <p className='text-[10px] uppercase tracking-wider text-gray-400'>
                      Fecha inicio
                    </p>
                    <p className='text-sm font-semibold text-slate-800'>
                      {formatDate(subscription.startDate)}
                    </p>
                  </div>
                  <div>
                    <p className='text-[10px] uppercase tracking-wider text-gray-400'>
                      Fecha fin
                    </p>
                    <p className='text-sm font-semibold text-slate-800'>
                      {formatEndDate(subscription.endDate)}
                    </p>
                  </div>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    )
  }
  
  return (
    <div className='space-y-4'>
      <div className='flex items-center justify-between'>
        <h2 className='text-xl font-bold text-gray-800'>Historial de Suscripciones</h2>
        <span className='text-xs font-medium uppercase tracking-[0.18em] text-gray-400'>
          {subscriptions.length} registros
        </span>
      </div>

      <div className='overflow-auto max-h-[400px] rounded-2xl'>
        <table className={historyTableStyles.table}>
          <thead className={historyTableStyles.thead}>
            <tr>
              <th className={historyTableStyles.th}>Plan</th>
              <th className={historyTableStyles.th}>Fecha inicio</th>
              <th className={historyTableStyles.th}>Fecha fin</th>
              <th className={historyTableStyles.th}>Estado</th>
            </tr>
          </thead>
          <tbody>
            {subscriptions.map(subscription => {
              const statusMeta = getSubscriptionStatusMeta(subscription)
              
              return (
                <tr key={subscription.id} className={historyTableStyles.tr}>
                  <td className={historyTableStyles.td}>
                    <div className='flex flex-col items-center justify-center'>
                      <span className={historyTableStyles.boldText}>
                        {subscription.plan?.name || 'Sin plan'}
                      </span>
                      {/*<span className={historyTableStyles.text}>Suscripcion #{subscription.id}</span>*/}
                    </div>
                  </td>
                  <td className={historyTableStyles.td}>
                    <span className={historyTableStyles.boldText}>
                      {formatDate(subscription.startDate)}
                    </span>
                  </td>
                  <td className={historyTableStyles.td}>
                    <span className={historyTableStyles.boldText}>
                      {formatEndDate(subscription.endDate)}
                    </span>
                  </td>
                  <td className={historyTableStyles.td}>
                    <span className={getStatusBadgeClass(statusMeta.tone)}>{statusMeta.label}</span>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default SubscriptionHistoryTable
